import React, { FC, memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { AppRoutes } from 'app/config/routerConfig/types';
import { useGetRentOptionsQuery } from 'entities/RentOption';
import { useSpecialPromotionModal } from 'features/SpecialPromotion';
import XmasEN from 'shared/assets/images/XmasEN.png';
import XmasDE from 'shared/assets/images/XmasDE.png';
import XmasENMobile from 'shared/assets/images/XmasENMobile.png';
import XmasDEMobile from 'shared/assets/images/XmasDEMobile.png';
import { getGlobalSettings } from 'app/appState';
import { useAppSelector } from 'app/config/storeConfig/hooks';
import { useScreenBreakpoints } from 'shared/utils/hooks/useScreenBreakpoints';
import { AppLanguage } from 'app/config/i18Config/types';
import i18n from 'app/config/i18Config/i18n';

export const ChristmasAndNewYearPromotionContent: FC = () => {
  const { t } = useAppTranslation('common');

  const navigate = useNavigate();

  const { data } = useGetRentOptionsQuery({ isSpecialPromotion: true });
  const { closeModal } = useSpecialPromotionModal();

  const globalSettings = useAppSelector(getGlobalSettings);

  const { isDesktop } = useScreenBreakpoints();

  const goToBooking = useCallback(() => {
    navigate(data?.length ? `${AppRoutes.BOOKING}?rentOptionId=${data[0].rentOptionId}` : AppRoutes.BOOKING);
    closeModal();
  }, [closeModal, data, navigate]);

  const currentLanguage = i18n.language as AppLanguage.en | AppLanguage.de;

  type DeviceType = 'desktop' | 'mobile';

  const promotionImageMap: Record<AppLanguage.en | AppLanguage.de, Record<DeviceType, string>> = {
    [AppLanguage.en]: {
      desktop: XmasEN,
      mobile: XmasENMobile,
    },
    [AppLanguage.de]: {
      desktop: XmasDE,
      mobile: XmasDEMobile,
    },
  };

  const deviceType: DeviceType = isDesktop ? 'desktop' : 'mobile';

  const promotionImage = promotionImageMap[currentLanguage]?.[deviceType] ?? promotionImageMap[AppLanguage.en][deviceType];

  return (
    <div>
      <img className="w-full cursor-pointer" src={promotionImage} alt="Christmas promotion" onClick={goToBooking} />
    </div>
  );
};
